<ng-container>
  <div class="page-title">
    <div [innerHTML]="'AddressInfo.Second.Title' | translate | safe:'html'" class="title"></div>
    <div [innerHTML]="'AddressInfo.Second.SubTitle' | translate | safe:'html'" class="sub-title"></div>
  </div>

  <app-address
    (addressModelChange)="updateUser()"
    [addressModel]="user.secondHolder.addressModel"
    [monitoring]="user.monitoring">
  </app-address>
</ng-container>

<ng-container>
  <div class="page-title">
    <div [innerHTML]="'CitizenshipInfo.Second.Title' | translate | safe:'html'" class="title"></div>
    <div [innerHTML]="'CitizenshipInfo.Second.SubTitle' | translate | safe:'html'" class="sub-title"></div>
  </div>

  <app-citizenship
    (citizenshipModelChange)="updateUser()"
    [citizenshipModel]="user.secondHolder.contactModel"
    [forbiddenIds]="[user.contactModel.idNumber]"
  >
  </app-citizenship>
</ng-container>
